<template>
    <div class="l-modal-congrats">
        <l-modal size="m" :close-on-backdrop-click="false" :show-close-btn-header="false">
            <template #header>{{ title }}</template>
            <template #body>
                <img :src="image" alt="Congrats" class="congrats-modal-image" />
                <br />
                <span class="congrats-modal-text">{{ text }}</span>

                <div class="congrats-modal-footer">
                    <button class="btn btn-primary btn-raised" type="button" @click="next()">
                        {{ btnText }}
                    </button>
                </div>
            </template>
        </l-modal>
    </div>
</template>

<script>
import LModal from "@/components/LModal";

export default {
    components: {
        LModal,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        btnText: {
            type: String,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
    methods: {
        next() {
            this.$emit("next");
        },
    },
};
</script>

<style scoped>
.congrats-modal-image {
    width: 50%;
    margin-left: 25%;
}

.congrats-modal-text {
    display: block;
    margin-top: 3rem;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 2rem;
}

.congrats-modal-footer {
    text-align: right;
    padding-top: 1rem;
}
.congrats-modal-footer >>> .btn {
    padding-left: 16px;
    padding-right: 16px;
}
</style>
